import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LogoGdgTwoLine from '../../../../Components/CustomIcons/LogoGdgTwoLine';
import logoFlame from '../../../../Assets/images/gases_logo_flame.png';
import { useMediaQuery } from '@material-ui/core';

const LogoHeaderGDG = () => {
  // * OTHER HOOKS
  const classes = useStyles();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

  // * FUNCTIONS
  const renderLogo = () => {
    if (isSmallScreen) {
      return <img src={logoFlame} alt="flame" className={classes.imageSmall} />;
    }

    return (
      <>
        <LogoGdgTwoLine className={classes.logo} />
      </>
    );
  };

  return <a href="/">{renderLogo()}</a>;
};

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',
    justifyContent: 'flex-start'
  },
  imageSmall: {
    cursor: 'pointer',
    width: 40
  },
  logo: {
    cursor: 'pointer',
    width: '128.3px',
    height: 56
  },
  biglogo: {
    cursor: 'pointer',
    width: '128.3px',
    height: 56
  },
  imageText: {
    marginTop: theme.spacing(0.5),
    height: '42px',
    width: '180px'
  },
  imageFlame: {
    height: '50px',
    width: '40px'
  }
}));

export default LogoHeaderGDG;
